import { getUserId } from "./api/api";
import { createRoot } from "react-dom/client";
import { AppWithProviders } from "./app";
import "./index.css";
import { CaptureConsole, ExtraErrorData } from "@sentry/integrations";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import "./i18n";

const getEnv = () => {
  if (window.location.origin.includes("staging.")) {
    return "staging";
  }
  if (window.location.origin.includes("dev.")) {
    return "dev";
  }
  if (window.location.origin.includes("local.")) {
    return "local";
  }

  return "prod";
};

const env = getEnv();
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    environment: env,
    dsn: "https://5ea7e234f7b04edb8b2b43ba6b25aa4b@o4504856132583424.ingest.sentry.io/4504856231608320",
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: env === "local" ? 1.0 : 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      new BrowserTracing(),
      new CaptureConsole({
        levels: ["error"],
      }),
      new ExtraErrorData({
        depth: 10,
      }),
      new Sentry.Replay(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}
// redirect www to non-www, keep everything else the same
const url = new URL(window.location.href);

if (url.hostname.startsWith("www.")) {
  window.location.href = url.href.replace(url.hostname, url.hostname.slice(4));
} else {
  //  getUserId().then(() => {
  const root = createRoot(document.getElementById("root")!);
  root.render(<AppWithProviders />);
  //  });

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  //reportWebVitals();
}
